import { creatorUseState } from '@derolfgroep/utils/lib/react/simpleStateManager/simpleStateManager'

export const useStateGroupId = creatorUseState({
  nameState: 'groupId',
  nameSetFunction: 'setGroupId',
})
